import {Repository, createRepository} from '@/repositories/Base/Repository'

class PermissionRepository extends Repository {
    endpoint = 'vam/vns/permissions'

}

export default new PermissionRepository()

export const create = createRepository(PermissionRepository)
